import {
  Assessment,
  GradeOutlined,
  BarChart,
  WorkOutline,
} from '@mui/icons-material';
import { RESOURCES, ACTIONS } from '../../../hooks/useAccessControl';

export const assessmentsMenu = {
  id: 'assessments',
  label: 'Assessments & Marks',
  icon: Assessment,
  children: [
    {
      type: 'group',
      id: 'assessments-entry',
      label: 'Marks Entry',
      children: [
        {
          id: 'assessments-marks',
          label: 'Enter Marks',
          icon: GradeOutlined,
          permission: { resource: RESOURCES.ASSESSMENTS.MARKS, action: ACTIONS.READ },
        },
      ],
    },
    {
      type: 'group',
      id: 'assessments-reporting',
      label: 'Reports',
      children: [
        {
          id: 'assessments-reports',
          label: 'Reports & Analytics',
          icon: BarChart,
          permission: { resource: RESOURCES.ASSESSMENTS.REPORTS, action: ACTIONS.READ },
        },
        {
          id: 'assessments-teacher-workload',
          label: 'Teacher Workload',
          icon: WorkOutline,
          permission: { resource: RESOURCES.ASSESSMENTS.REPORTS, action: ACTIONS.READ },
        },
      ],
    },
  ],
};
